<template>
  <b-navbar-nav class="d-flex ml-auto linkscenter">
      <b-nav-form id="sitesearch" @submit.prevent="processForm()">
        <b-form-input
          type="search"
          name="mainsearch"
          size="sm"
          class="form-control mr-sm-2"
          placeholder=""
          v-model="mainsearch"
        >
        </b-form-input>
        <b-button
          :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="#nav-collapse"
          @click="visible = false"
          class="nav-link my-2 my-sm-0"
          type="submit"
          >Search</b-button
        >
      </b-nav-form>
  </b-navbar-nav>
</template>
<script>
/* eslint-disable */
export default {
  name: "MainSearch",
  data () {
    return {
      mainsearch: '',
      visible: false
    }
  },
    computed: {
      processForm() {
            return function() {
            this.$router.push({name: "Searchslug", params: { slug: this.mainsearch }})
            this.mainsearch = ''
            };
        }
    }
};
</script>
